const styles = () => ({
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
